<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="printAllButtonLoading"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>cloud_download</v-icon>Export
              </v-btn>
            </template>

            <v-list>
              <v-list-tile @click="printAll('printReport')">
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="issueNo"
                label="Invoice No"
                type="text"
                v-model="queryParams.invoiceNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="shopList"
                label="Select Shop"
                v-model="queryParams.shopId"
                item-text="name"
                item-value="id"
                :readonly="user.role.roleName == 'BRANCH_ADMIN'"
                @change="changeShop($event)"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-autocomplete
                v-model="queryParams.customerIds"
                :items="selectedCustomerList"
                label="Customer"
                @click="showCustomers()"
                item-text="code"
                item-value="id"
                multiple
                menu-props="auto"
                autocomplete
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="categoryGroup"
                label="Category Group"
                v-model="categoryGroupName"
                type="text"
                @click="showCategoryGroup()"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title class="blue darken-3">
            <span class="headline white--text">Summary</span>
            <v-spacer></v-spacer>
            <v-icon @click="show = !show" class="white--text">{{
              show ? "keyboard_arrow_up" : "keyboard_arrow_down"
            }}</v-icon>
          </v-card-title>
          <v-card-text class="font-weight-bold" v-show="show">
            <div>
              <span>Total Amount :</span>
              <v-chip>
                <span>{{ totalDamageAmount | decFormat(6) }}</span>
              </v-chip>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="damageSaleList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template slot="items" slot-scope="props">
              <td>
                {{
                  props.item.updatedDateInMilliSeconds | format-ms-date
                }}
              </td>
              <td>{{ props.item.invoiceNo }}</td>
              <td>{{ props.item.customerDTO.name }}</td>
              <td>{{ props.item.customerDTO.code }}</td>
              <td>{{ props.item.shopDTO.name }}</td>
              <td>{{ props.item.invoiceType }}</td>
              <td>{{ props.item.damageStatus }}</td>
              <td>{{ props.item.shopDTO.regionName }}</td>
              <td style="text-align: right">
                {{ props.item.totalPrice | decFormat(6) }}
              </td>
              <td>{{ props.item.remark }}</td>
              <td>{{ props.item.updatedBy }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- customer dialog -->
    <v-dialog v-model="showCustomerListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md3>
              <v-text-field
                name="name"
                label="Customer Name"
                type="text"
                class="mr-1"
                v-model="customerQueryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field
                name="code"
                label="Customer Code"
                type="text"
                class="mr-1"
                v-model="customerQueryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field
                name="email"
                label="Customer Email"
                type="text"
                class="mr-1"
                v-model="customerQueryParams.email"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearchCustomer">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Customer List Section -->
          <v-flex xs12 class="mt-1">
            <v-data-table
              v-model="selectedCustomerList"
              :headers="customerHeader"
              :items="activeCustomerList"
              select-all
              class="elevation-1"
              :loading="showListLoading"
              :total-items="customertotalRows"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="customerpagination"
              :must-sort="true"
            >
              <template slot="headers" slot-scope="props">
                <tr>
                  <th>
                    <v-checkbox
                      primary
                      hide-details
                      @click.native="toggleAll"
                      :input-value="props.all"
                      :indeterminate="props.indeterminate"
                    ></v-checkbox>
                  </th>
                  <th v-for="header in props.headers" :key="header.text">
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <td>
                  <v-checkbox
                    primary
                    hide-details
                    :input-value="props.selected"
                    :value="props.item"
                    :indeterminate="props.indeterminate"
                    v-model="selectedCustomerList"
                    multiple
                  ></v-checkbox>
                </td>
                <td>
                  <a>{{ props.item.code }}</a>
                </td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.email }}</td>
                <td>{{ props.item.phoneNo }}</td>
                <td>{{ props.item.creditLevel.name }}</td>
              </template>
            </v-data-table>
            <div class="text-xs-right">
              <v-btn color="primary" @click="setCustomer">Ok</v-btn>
            </div>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- category group dialog -->
    <v-dialog
      v-model="showCategoryGroupListDialog"
      scrollable
      max-width="1000px"
    >
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md3>
              <v-text-field
                name="name"
                label="Category Group Name"
                type="text"
                class="mr-1"
                v-model="categoryGroupParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field
                name="code"
                label="Category Group Code"
                type="text"
                class="mr-1"
                v-model="categoryGroupParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md3>
              <v-text-field
                name="status"
                label="Status"
                type="text"
                class="mr-1"
                v-model="categoryGroupParams.status"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearchCategoryGroup">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- List Section -->
          <v-flex xs12 class="mt-1">
            <v-data-table
              :headers="categoryGroupHeader"
              :items="categoryGroupList"
              class="elevation-1"
              :loading="showListLoading"
              :total-items="categoryGroupTotalRows"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="categoryGroupPagination"
              :must-sort="true"
            >
              <template slot="items" slot-scope="props">
                <td>
                  <a @click="setCategoryGroup(props.item)">{{
                    props.item.code
                  }}</a>
                </td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.status }}</td>
                <td>{{ props.item.updatedBy }}</td>
                <td>
                  {{
                    props.item.updatedDateInMilliSeconds | format-ms-date
                  }}
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- <summary report> -->
    <div
      id="printReport"
      style="border: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 18px; margin: 1px" v-if="shopName">
          {{ shopName }}
        </p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          Damage Sale Return(Not Approved)
        </p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          From: [{{ queryParams.fromDate }}] To: [{{ queryParams.toDate }}]
        </p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 12px;
            border-top: 1px solid black;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="border: 1px solid black; text-align: center">
                Invoice Date
              </th>
              <th style="border: 1px solid black; text-align: center">
                Invoice No
              </th>
              <th style="border: 1px solid black; text-align: center">
                Customer
              </th>
              <th style="border: 1px solid black; text-align: center">
                Category Group
              </th>
              <th style="border: 1px solid black; text-align: center">
                Product Name
              </th>
              <th style="border: 1px solid black; text-align: center">Price</th>
              <th style="border: 1px solid black; text-align: center">Qty</th>
              <th style="border: 1px solid black; text-align: center">Unit</th>
              <th style="border: 1px solid black; text-align: center">
                Amount
              </th>
            </tr>
          </thead>
          <tbody
            v-for="(
              damageHeader, index
            ) in damageHeaderPageDTO.damageHeaderList"
            :key="index"
          >
            <tr v-for="(item, i) in damageHeader.damageDetailList" :key="i">
              <td
                v-if="i == 0"
                :rowspan="damageHeader.damageDetailList.length"
                style="
                  border: 1px solid black;
                  text-align: left;
                  vertical-align: text-top;
                "
              >
                {{ item.updatedDateInMilliSeconds | format-ms-date }}
              </td>
              <td
                v-if="i == 0"
                :rowspan="damageHeader.damageDetailList.length"
                style="
                  border: 1px solid black;
                  text-align: left;
                  vertical-align: text-top;
                "
              >
                {{ item.invoiceNo }}
              </td>
              <td
                v-if="i == 0"
                :rowspan="damageHeader.damageDetailList.length"
                style="
                  border: 1px solid black;
                  text-align: left;
                  vertical-align: text-top;
                "
              >
                {{ item.customerName }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.categoryGroupName }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.productName }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.price | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.qty | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.factorUnitName }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.totalPrice | decFormat(6) }}
              </td>
            </tr>
            <tr>
              <td
                style="
                  border: 1px solid black;
                  font-weight: bold;
                  text-align: right;
                "
                colspan="8"
              >
                Sub Total
              </td>
              <td
                style="
                  border: 1px solid black;
                  font-weight: bold;
                  text-align: right;
                "
              >
                {{ damageHeader.totalPrice | decFormat(6) }}
              </td>
            </tr>
          </tbody>
          <tr>
            <td
              style="
                border: 1px solid black;
                font-weight: bold;
                text-align: right;
              "
              colspan="8"
            >
              Grand Total
            </td>
            <td
              style="
                border: 1px solid black;
                font-weight: bold;
                text-align: right;
              "
            >
              {{ damageHeaderPageDTO.totalDamageAmount | decFormat(6) }}
            </td>
          </tr>
        </table>
      </div>
    </div>
  </v-container>
</template>

<script>
import { commonService } from "../../services/common-service";
import { customerService } from "../../services/customer-service";
import { shopService } from "../../services/shop-service";
import { categoryGroupService } from "../../services/category-group-service";
import { damageService } from "../../services/damage-service";

export default {
  name: "DamageSaleApprovedReportByCategoryGroup",
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showFilters: false,
    show: false,
    breadcrumbs: [
      {
        text: "Reports",
        disabled: true,
      },
      {
        text: "Sale Reports",
        disabled: true,
      },
      {
        text: "Damage Sale (Not Approved) Report By Category Group",
        disabled: true,
      },
    ],
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      invoiceNo: "",
      customerIds: "",
      shopId: "",
      status: "DRAFT",
      categoryGroupId: "",
    },
    selectedCustomerList: [],
    customerQueryParams: {
      name: "",
      code: "",
      email: "",
    },
    showCustomerListDialog: false,
    showListLoading: false,
    customerpagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "name",
      totalItems: 0,
    },
    activeCustomerList: [],
    customertotalRows: 0,
    rowsPerPageItems: [25, 50, 100],
    customerHeader: [
      { text: "Code", align: "left", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Email", value: "email" },
      { text: "PhoneNo", value: "phoneNo" },
      { text: "Credit Level", value: "creditLevel", sortable: false },
    ],
    shopList: [],
    shopName: "",
    categoryGroupName: "",
    categoryGroupParams: {
      name: "",
      code: "",
      status: "",
    },
    categoryGroupPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "name",
      totalItems: 0,
    },
    categoryGroupList: [],
    printAllButtonLoading: false,
    damageHeaderPageDTO: new Object(),
    categoryGroupTotalRows: 0,
    showCategoryGroupListDialog: false,
    categoryGroupHeader: [
      { text: "Code", align: "left", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Status", value: "status", sortable: false },
      { text: "Updated By", value: "updatedBy", sortable: false },
      { text: "Updated Date", value: "updatedDate" },
    ],
    clonequeryParams: {},
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "",
      totalItems: 0,
    },
    damageSaleList: [],
    totalRows: 0,
    totalDamageAmount: 0,
    decimalFormat: "",
    headers: [
      {
        text: "Invoice Date",
        align: "left",
        value: "warehouse.name",
        sortable: false,
      },
      { text: "Invoice No", align: "left", value: "bin.name", sortable: false },
      { text: "Customer Name", value: "issueDate", sortable: false },
      { text: "Customer Code", value: "issueNo", sortable: false },
      { text: "Shop Name", value: "poNo", sortable: false },
      { text: "Invoice Type", value: "invoiceType", sortable: false },
      { text: "Status", value: "status", sortable: false },
      { text: "Region", value: "description", sortable: false },
      { text: "Total Damage Amount", value: "updatedDate", sortable: false },
      { text: "Remark", align: "center", sortable: false },
      { text: "Updated  By", value: "updatedBy", sortable: false },
    ],
  }),
  watch: {
    pagination: {
      handler() {
        this.getDamageSaleReportByCategoryGroup();
      },
      deep: true,
    },
    customerpagination: {
      handler() {
        this.getActiveCustomer();
      },
      deep: true,
    },
    categoryGroupPagination: {
      handler() {
        this.getCategoryGroup();
      },
      deep: true,
    },
  },
  created() {
    if (this.user.role.roleName == "BRANCH_ADMIN") {
      this.queryParams.shopId = this.user.shopId;
    }
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.invoiceNo) {
      this.queryParams.invoiceNo = this.$route.query.invoiceNo;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.categoryGroupId) {
      this.queryParams.categoryGroupId = this.$route.query.categoryGroupId;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.decimalFormat = commonService.formatdecimal();
    this.queryParams.status = "DRAFT";
    this.onSearch();
    this.getShopList();
  },
  methods: {
    getShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    showCustomers() {
      // Clean query params
      this.customerQueryParams.code = "";
      this.customerQueryParams.name = "";
      this.customerQueryParams.email = "";
      this.selectedCustomerList = [];
      this.queryParams.customerIds = [];

      this.getActiveCustomer().then(
        (this.showCustomerListDialog = !this.showCustomerListDialog)
      );
    },
    getActiveCustomer() {
      this.showListLoading = true;
      let order = this.customerpagination.descending ? "desc" : "asc";
      return customerService
        .getCustomers(
          this.customerQueryParams,
          this.customerpagination.page,
          this.customerpagination.rowsPerPage,
          this.customerpagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.activeCustomerList = res.data.customerList;
            this.customertotalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onSearchCustomer() {
      this.customerQueryParams.page = this.customerpagination.page;
      this.customerQueryParams.size = this.customerpagination.rowsPerPage;
      this.getActiveCustomer();
    },
    toggleAll() {
      if (this.selectedCustomerList.length) {
        this.selectedCustomerList = [];
      } else {
        this.selectedCustomerList = this.activeCustomerList.slice();
      }
    },
    setCustomer() {
      if (this.selectedCustomerList.length) {
        this.queryParams.customerIds = [];
        this.selectedCustomerList.forEach((element) => {
          if (!this.queryParams.customerIds.includes(element.id))
            this.queryParams.customerIds.push(element.id);
        });
      }
      this.showCustomerListDialog = !this.showCustomerListDialog;
    },
    changeShop(item) {
      this.shopName = this.shopList.filter((shop) => shop.id == item)[0].name;
      this.shopCode = this.shopList.filter((shop) => shop.id == item)[0].code;
    },
    showCategoryGroup() {
      // Clean query params
      this.categoryGroupParams.code = "";
      this.categoryGroupParams.name = "";
      this.categoryGroupParams.status = "";
      this.queryParams.categoryGroupId = "";
      this.categoryGroupName = "";

      this.getCategoryGroup().then(
        (this.showCategoryGroupListDialog = !this.showCategoryGroupListDialog)
      );
    },
    getCategoryGroup() {
      this.showListLoading = true;
      let order = this.categoryGroupPagination.descending ? "desc" : "asc";
      return categoryGroupService
        .getCategoryGroupList(
          this.categoryGroupParams,
          this.categoryGroupPagination.page,
          this.categoryGroupPagination.rowsPerPage,
          this.categoryGroupPagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.categoryGroupList = res.data.categoryGroupList;
            this.categoryGroupTotalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onSearchCategoryGroup() {
      this.categoryGroupParams.page = this.categoryGroupPagination.page;
      this.categoryGroupParams.size = this.categoryGroupPagination.rowsPerPage;
      this.getCategoryGroup();
    },
    setCategoryGroup(categoryGroup) {
      this.queryParams.categoryGroupId = categoryGroup.id;
      this.categoryGroupName = categoryGroup.name;
      this.showCategoryGroupListDialog = !this.showCategoryGroupListDialog;
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "damage-sale-not-approved-by-category-group",
        query: this.queryParams,
      });
      this.getDamageSaleReportByCategoryGroup();
      this.clonequeryParams = JSON.parse(JSON.stringify(this.queryParams));
    },
    getDamageSaleReportByCategoryGroup() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      damageService
        .getDamageSaleReportByCategoryGroup(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.damageSaleList = res.data.damageHeaderList;
            this.totalRows = res.data.totalElements;
            this.totalDamageAmount = res.data.totalDamageAmount;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    printAll(divName) {
      this.printAllButtonLoading = true;
      damageService
        .getDamageSaleReportByCategoryGroupPrint(this.clonequeryParams)
        .then((res) => {
          if (res.data) {
            this.damageHeaderPageDTO = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.printAllButtonLoading = false;
        });
    },
  },
};
</script>